<template>
  <div class="product-container">
    <!-- <nav class="nav-header">
      <p @click="$router.push({name: 'reseller'})"
         :class="($route.name === 'reseller-portal-customization') ? 'active' : ''">Portal Customization</p>
      <p @click="$router.push({name: 'reseller-payment-gateway'})"
         :class="($route.name === 'reseller-payment-gateway') ? 'active' : ''">Payment Gateway</p>
    </nav>-->
    <router-view class="router-container" />
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    showSms: true,
  }),
};
</script>

<style lang="scss" scoped>
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 15px 0px 15px;
    display: flex;
    p {
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      color: #bdbfd8;
      font-family: "" Helvetica Neue "";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
      margin-right: 10px;
      margin-bottom: 0;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
    padding: 20px;
  }
}
</style>

